import { useEffect, useRef, useState } from "react";
import eventService from "../services/eventService";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

export default function useEventState() {
  const { currentUser, setEventManagerLoading } = useAppContext();

  const [schoolyears, setSchoolyears] = useState([]);
  const [selectedSchoolyear, setSelectedSchoolyear] = useState(null);

  const [events, setEvents] = useState([]); // ✅ NEW
  const [selectedEvent, setSelectedEvent] = useState(null); // ✅ NEW

  const [shifts, setShifts] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [angebote, setAngebote] = useState([]);

  const selectedSchoolyearIdRef = useRef(null);
  const selectedEventIdRef = useRef(null);

  /**
   * =========================================================
   * ✅ keep ref updated
   * =========================================================
   */
  useEffect(() => {
    selectedSchoolyearIdRef.current = selectedSchoolyear?.id;
  }, [selectedSchoolyear]);
  useEffect(() => {
    selectedEventIdRef.current = selectedEvent?.id;
  }, [selectedEvent]);

  /**
   * =========================================================
   * ✅ reset on logout
   * =========================================================
   */
  useEffect(() => {
    if (!currentUser) {
      setSchoolyears([]);
      setSelectedSchoolyear(null);

      setEvents([]);
      setSelectedEvent(null);

      setShifts([]);
      setJobs([]);
      setAngebote([]);
    }
  }, [currentUser]);

  /**
   * =========================================================
   * ✅ load schoolyears
   * =========================================================
   */
  useEffect(() => {
    if (!currentUser) return;

    const loadSchoolyears = async () => {
      const res = await eventService.getSchoolyears();
      setSchoolyears(res.reverse());
      // console.log(res);
      if (res.length > 0) {
        setSelectedSchoolyear(res[0]);
      }
    };

    loadSchoolyears();
  }, [currentUser]);

  /**
   * =========================================================
   * ✅ load EVENTS (NEW STEP ✅)
   * =========================================================
   */
  useEffect(() => {
    if (!selectedSchoolyear?.id) return;

    // CLEAR OLD DATA IMMEDIATELY
    setSelectedEvent(null);
    setShifts([]);
    setJobs([]);
    setAngebote([]);

    const loadEvents = async () => {
      try {
        const res = await eventService.getEvents(selectedSchoolyear.id);

        setEvents(res);

        // ✅ select first event OR none
        if (res.length > 0) {
          setSelectedEvent(res[0]);
        } else {
          setSelectedEvent(null);
        }
      } catch (err) {
        console.error("Error loading events:", err);
        setEvents([]);
        setSelectedEvent(null);
      }
    };

    loadEvents();
  }, [selectedSchoolyear?.id]);

  /**
   * =========================================================
   * ✅ load EVENT data (was schoolyear before ✅)
   * =========================================================
   */
  const loadSommerData = async (eventIdParam) => {
    const eventId = eventIdParam || selectedEvent?.id;
    if (!eventId) return;

    try {
      const data = await eventService.getSommerData(eventId);

      const allJobs = [];
      const allAngebote = [];

      data.forEach((shift) => {
        shift.jobs.forEach((job) => {
          allJobs.push({ ...job, shiftId: shift.id });

          job.angebote.forEach((a) => {
            allAngebote.push({ ...a, jobId: job.id });
          });
        });
      });

      setShifts(data);
      setJobs(allJobs);
      setAngebote(allAngebote);
    } catch (err) {
      console.error("❌ Error loading EventManager:", err);
    }
  };

  /**
   * =========================================================
   * ✅ initial load (NOW BASED ON EVENT ✅)
   * =========================================================
   */
  useEffect(() => {
    if (!currentUser?.id || !selectedEvent?.id) return;
    const loadData = async () => {
      setEventManagerLoading(true); // ✅ start loading

      try {
        await loadSommerData(selectedEvent.id);
      } finally {
        setEventManagerLoading(false); // ✅ finish loading
      }
    };

    loadData();
  }, [currentUser, selectedEvent]);

  /**
   * =========================================================
   * ✅ RETURN API
   * =========================================================
   */
  return {
    schoolyears,
    setSchoolyears,
    selectedSchoolyear,
    setSelectedSchoolyear,
    selectedSchoolyearIdRef,
    selectedEventIdRef,
    events,
    setEvents,
    selectedEvent,
    setSelectedEvent,

    shifts,
    setShifts,
    jobs,
    setJobs,
    angebote,
    setAngebote,

    loadSommerData,
  };
}
